var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharedFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.81295 5.00012C4.33213 5.00012 3.871 5.19113 3.531 5.53112C3.19101 5.87112 3 6.33225 3 6.81307V17.6908C3 18.1716 3.19101 18.6327 3.531 18.9727C3.87099 19.3127 4.33213 19.5037 4.81295 19.5037H8.64029V18.7383C8.64029 17.5603 9.10826 16.4305 9.94124 15.5975C10.1737 15.3651 10.4293 15.161 10.7026 14.9877C10.1962 14.4224 9.88816 13.6757 9.88816 12.857C9.88816 11.0929 11.3183 9.66276 13.0824 9.66276C14.4676 9.66276 15.6468 10.5445 16.0895 11.7773C16.5867 11.3481 17.2344 11.0886 17.9428 11.0886C18.712 11.0886 19.4097 11.3946 19.9209 11.8916V9.23034C19.9209 8.74951 19.7299 8.28838 19.3899 7.94839C19.0499 7.6084 18.5887 7.41739 18.1079 7.41739H10.554L9.28489 5.7253C9.11602 5.50014 8.89705 5.31739 8.64531 5.19152C8.39357 5.06565 8.11599 5.00012 7.83453 5.00012H4.81295Z",
    fill: "#474747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3934 13.0221C15.3934 14.2594 14.3903 15.2603 13.1529 15.2603C11.9156 15.2603 10.9125 14.2594 10.9125 13.0221C10.9125 11.7847 11.9156 10.7801 13.1529 10.7801C14.3903 10.7801 15.3934 11.7847 15.3934 13.0221Z",
    fill: "#474747"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8339 14.3387C19.8339 15.3511 19.0124 16.0785 18 16.0785C16.9876 16.0785 16.1661 15.3511 16.1661 14.3387C16.1661 13.3263 16.9876 12.4108 18 12.4108C19.0124 12.4108 19.8339 13.3263 19.8339 14.3387Z",
    fill: "#474747"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48633 19.5083C9.48633 18.536 9.87259 17.6035 10.5601 16.9159C11.2477 16.2284 12.1802 15.8421 13.1525 15.8421C14.1249 15.8421 15.0574 16.2284 15.7449 16.9159C15.8486 17.0196 15.974 17.1613 16.0809 17.2925C16.3415 17.0674 17.0563 16.5102 17.7461 16.5102C18.6104 16.5102 19.439 16.8249 20.0502 17.3851C20.6613 17.9453 21 18.7188 21 19.5111L9.48633 19.5083Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharedFolderIcon);
export default __webpack_public_path__ + "static/media/shared-folder_icon.7768e1ffa06102b7fe8e3f66f2ba1745.svg";
export { ForwardRef as ReactComponent };